var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { applySpacings } from '../../utils/tailwind';
import { Box } from '../Box/Box';
import { useColorSet } from '../ThemeProvider/useColorSet';
import { Typography } from '../Typography/Typography';
import { divider } from './styles';
export const Divider = (_a) => {
    var { text, position = 'start', orientation = 'horizontal', thickness = 1, colorSet, gradientColor, className } = _a, props = __rest(_a, ["text", "position", "orientation", "thickness", "colorSet", "gradientColor", "className"]);
    const colors = useColorSet({ colorSet });
    const { container, line } = divider({
        orientation,
        gradient: gradientColor,
    });
    return (_jsxs(Box, Object.assign({ className: container({ className: [applySpacings(props), className] }) }, props, { children: [(position === 'end' || position === 'center') && (_jsx("span", { className: line(), style: {
                    '--thickness-var': `${thickness}px`,
                    '--background-var': colors.border,
                } })), text && (_jsx("div", { className: "whitespace-nowrap", children: _jsx(Typography, { variant: "footnote", color: colors.content, children: text }) })), (!position || position === 'start' || position === 'center') && (_jsx("span", { className: line(), style: {
                    '--thickness-var': `${thickness}px`,
                    '--background-var': colors.border,
                } }))] })));
};
